define('services/portalstorage',["require", "exports", "models/event", "models/account", "services/settings", "services/jsonconverter", "services/azurestorage"], function (require, exports, Event, Account, Configuration, JsonConverter, azureStorage) {
    "use strict";
    var Property = (function () {
        function Property() {
        }
        return Property;
    }());
    exports.Property = Property;
    var StoredFile = (function () {
        function StoredFile() {
        }
        return StoredFile;
    }());
    exports.StoredFile = StoredFile;
    var AzureUploadDetails = (function () {
        function AzureUploadDetails() {
        }
        return AzureUploadDetails;
    }());
    exports.AzureUploadDetails = AzureUploadDetails;
    var StatusEventArgs = (function () {
        function StatusEventArgs(message, response) {
            this.message = message;
            this.response = response;
        }
        return StatusEventArgs;
    }());
    exports.StatusEventArgs = StatusEventArgs;
    var ProgressEventArgs = (function () {
        function ProgressEventArgs(total, loaded) {
            this.total = total;
            this.loaded = loaded;
        }
        return ProgressEventArgs;
    }());
    exports.ProgressEventArgs = ProgressEventArgs;
    var Connector = (function () {
        function Connector() {
            this._done = new Event.Delegate();
        }
        Object.defineProperty(Connector.prototype, "done", {
            get: function () {
                return this._done;
            },
            enumerable: true,
            configurable: true
        });
        Connector.prototype.createUpload = function (file, metadata) {
            var data = new FormData();
            data.append(file.name, file);
            var worker = new Worker;
            worker.initialize(data, file);
            return worker;
        };
        Connector.prototype.delete = function (id) {
            if (azureStorage.useAzureStorage()) {
                return;
            }
            var url = Configuration.Settings.getServiceFor("portalstorage", "delete/temporary/" + "document.tmp", "?id=" + id); //+ "&sessionId=" + Account.Session.getSessionId()
            var contentType = 'application/json';
            var options = {
                type: "DELETE",
                contentType: contentType,
                beforeSend: function (req) {
                    //req.setRequestHeader("Origin", configuration.Settings.getScope());
                    if (Account.Session.isAuthenticated) {
                        req.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                    }
                }
            };
            return jQuery.ajax(url, options);
        };
        return Connector;
    }());
    exports.Connector = Connector;
    var Tools = (function () {
        function Tools() {
        }
        Tools.generatePreview = function (file, target) {
            if ((/image/i).test(file.type)) {
                var fileReader = new FileReader();
                fileReader.onload = function (ev) {
                    target(ev.target.result);
                };
                fileReader.readAsDataURL(file);
            }
            else {
                target("content/thumbnails/documentupload.png");
            }
        };
        return Tools;
    }());
    exports.Tools = Tools;
    var Worker = (function () {
        function Worker() {
            this.onDone = function (e) { };
            this.onError = function (e) { };
            this.onProgress = function (e) { };
        }
        Worker.prototype.initialize = function (data, file) {
            this._data = data;
            this._file = file;
        };
        Worker.prototype.start = function (azureUploadDetails) {
            var _this = this;
            var request = new XMLHttpRequest();
            request.onerror = function (ev) { return _this.onError(new StatusEventArgs("Es trat ein Fehler auf. Bitte wenden Sie sich an den Support.", null)); };
            request.upload.onprogress = function (ev) { return _this.onProgress(new ProgressEventArgs(ev.total, ev.loaded)); };
            if (azureUploadDetails != null && azureStorage.useAzureStorage()) {
                var azureUrlDetails = azureStorage.getBlobUploadUrl(azureUploadDetails.organizationId);
                var storedFiles = [];
                var storedFile = new StoredFile();
                storedFile.id = azureUrlDetails.blobName;
                storedFile.fileName = this._file.name;
                storedFiles.push(storedFile);
                request.onload = function (ev) { return _this.onDone(new StatusEventArgs(request.statusText, storedFiles)); };
                request.open("PUT", azureUrlDetails.url, true);
                request.setRequestHeader("x-ms-blob-type", "BlockBlob");
                request.setRequestHeader("x-ms-blob-content-disposition", "filename=" + this._file.name);
                request.send(this._file);
            }
            else {
                request.onload = function (ev) { return _this.onDone(new StatusEventArgs(request.statusText, _this.parseResponse(request.response))); };
                var url = Configuration.Settings.getServiceFor("portalstorage", "upload/temporary/" + "document.tmp", null); //"?sessionId=" + Account.Session.getSessionId()
                request.open("POST", url, true);
                request.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                //request.setRequestHeader("Content-Type", "multipart/form-data");
                request.send(this._data);
            }
        };
        Worker.prototype.parseResponse = function (response) {
            var item = jQuery.parseJSON(response);
            return new JsonConverter().convertPropertyNamesToCamelCase(item);
        };
        return Worker;
    }());
});

